var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-main-email"
  }, [_c('Form', {
    ref: "formEmail",
    attrs: {
      "model": _vm.login.formData,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("padf2", "邮箱"),
      "rules": _vm.rules.email,
      "prop": "email"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": $t("padf2", "邮箱"),
      "element-id": "loginFormInputEmail"
    },
    on: {
      "input": () => _vm.onInputRange(this, _vm.login.formData, 'email', 'loginFormInputEmail'),
      "on-enter": _vm.handleContinue
    },
    model: {
      value: _vm.login.formData.email,
      callback: function ($$v) {
        _vm.$set(_vm.login.formData, "email", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "login.formData.email"
    }
  })], 1), _c('LoginPasswordType', {
    ref: "loginPasswordTypeEmail",
    attrs: {
      "data": _vm.passwordType,
      "password-required-message": $t("c2r1q94", "密码必填")
    },
    on: {
      "on-change": _vm.onChange,
      "on-send-verify": _vm.handleSuccessVerify,
      "on-enter": _vm.handleContinue
    }
  }), _c('Agreenment', {
    staticClass: "agreenment",
    model: {
      value: _vm.login.loginAgreement,
      callback: function ($$v) {
        _vm.$set(_vm.login, "loginAgreement", $$v);
      },
      expression: "login.loginAgreement"
    }
  }), _c('Button', {
    staticClass: "continue-btn",
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": _vm.handleContinue
    }
  }, [_vm._v(` ${$t("ma5i2", "继续")} `), _c('Icon', {
    staticClass: "continue-icon",
    attrs: {
      "type": "md-arrow-forward"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };